import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthService} from '../../../services/auth';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GeneralModalComponent} from "../../../modals/general/general-modal/general-modal.component";
import {User} from "../../../classes/user";
import {mergeMap, tap} from "rxjs/operators";
import {InspectionDeliveryRequestService} from "../../../services/inspectionDeliveryRequest";
import {InspectionDeliveryRequest} from "../../../classes/inspectionDeliveryRequest";
import {InspectionOrder} from "../../../classes/inspectionOrder";
import {InspectionOrderService} from "../../../services/inspectionOrder";

@Component({
  selector: 'app-inspection-order-detail',
  templateUrl: './inspection-order-detail.component.html',
  styleUrls: ['./inspection-order-detail.component.css']
})
export class InspectionOrderDetailComponent implements OnInit {
  // Pagination Parameters
  paginationConfig = {
    itemsPerPage: 10,
    currentPage: 1
  };
  paginationParams = {
    autoHide: true,
    maxSize: 7,
    responsive: true
  };
  paginationLabels = {
    previousLabel: 'Precedente',
    nextLabel: 'Successiva',
    screenReaderPaginationLabel: 'Paginazione',
    screenReaderPageLabel: 'pagina',
    screenReaderCurrentLabel: `Sei sulla pagina`
  };

  // Inspection Data
  user!: User;
  inspectionOrder!: InspectionOrder;
  inspectionDeliveryRequests: Array<InspectionDeliveryRequest> = [];

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService,
              private modalService: NgbModal,
              private inspectionOrderService: InspectionOrderService,
              private inspectionDeliveryRequestService: InspectionDeliveryRequestService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.inspectionOrderService.getByID(params.get('id'))
          .pipe(
              tap((inspectionOrder: any) => {
                this.inspectionOrder = inspectionOrder;
              }),
              mergeMap(() => this.inspectionDeliveryRequestService.getByIDInspectionOrder(params.get('id'))),
          )
          .subscribe({
            next: (inspectionDeliveryRequests: any) => {
              this.inspectionDeliveryRequests = inspectionDeliveryRequests;
            },
            error: (err: HttpErrorResponse) => {
              console.log(err);
            }
          });
    });
    this.user = this.authService.getUser();
  }

  pageChanged(event: any) {
    this.paginationConfig.currentPage = event;
  }

  openDeleteInspectionOrderModal() {
    const modalRef = this.modalService.open(GeneralModalComponent);
    modalRef.componentInstance.title = 'Rimozione <strong>Ordinativo</strong>';
    modalRef.componentInstance.text = 'Confermi la rimozione dell\'ordinativo numero "' + this.inspectionOrder.number + '"?';
    modalRef.result.then(() => {
      if (this.inspectionOrder.id_inspection_order) {
        this.inspectionOrderService.delete(this.inspectionOrder.id_inspection_order)
            .subscribe({
              next: () => {
                this.router.navigate(['/inspection']);
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            });
      }
    });
  }

  openDeleteInspectionDeliveryRequestModal(inspectionDeliveryRequest: InspectionDeliveryRequest) {
    const modalRef = this.modalService.open(GeneralModalComponent);
    modalRef.componentInstance.title = 'Rimozione <strong>Richiesta di Consegna</strong>';
    modalRef.componentInstance.text = 'Confermi la rimozione della richiesta di consegna con protocollo ente "' + inspectionDeliveryRequest.institution_protocol + '"?';
    modalRef.result.then(() => {
      if (inspectionDeliveryRequest.id_inspection_delivery_request) {
        this.inspectionDeliveryRequestService.delete(inspectionDeliveryRequest.id_inspection_delivery_request)
            .subscribe({
              next: () => {
                this.inspectionDeliveryRequests = this.inspectionDeliveryRequests.filter((currInspectionDeliveryRequest: InspectionDeliveryRequest) =>
                    currInspectionDeliveryRequest.id_inspection_delivery_request !== inspectionDeliveryRequest.id_inspection_delivery_request);
                this.paginationConfig.currentPage = 1;
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            });
      }
    });
  }
}
